import { Tabs } from '@inflearn/ds-react';
import { SUPPORTED_LANGUAGES, useLang } from '@inflearn/i18n-tools';
import { find } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';

const POLICY_CATEGORY = [
  { title: '통합서비스 이용약관', href: '/policy' },
  { title: '인프런 이용약관', href: '/policy/terms-of-service' },
  { title: '개인정보 처리방침', href: '/policy/privacy' },
] as const;

const POLICY_CATEGORY_JA = [
  { title: '특정 상거래법.short', href: '/policy/specified-commercial-transactions' },
] as const;

export const PolicyTabs = () => {
  const { lang } = useLang();
  const isJa = lang === SUPPORTED_LANGUAGES.ja;

  const { t } = useTranslation();
  const router = useRouter();

  const getActiveTabValue = () => {
    if (router.pathname.includes('/previous-terms-of-service')) {
      return find(POLICY_CATEGORY, { title: '인프런 이용약관' })?.href;
    }

    if (router.pathname.includes('/previous-privacy')) {
      return find(POLICY_CATEGORY, { title: '개인정보 처리방침' })?.href;
    }

    if (isJa && router.pathname.includes('/specified-commercial-transactions')) {
      return find(POLICY_CATEGORY_JA, { title: '특정 상거래법.short' })?.href;
    }

    return router.pathname;
  };

  return (
    <Tabs value={getActiveTabValue()} w="100%" pt={32} wrap="nowrap">
      <Tabs.List w="100%">
        {POLICY_CATEGORY.map((category) => (
          <Link key={category.href} href={category.href}>
            <Tabs.Tab value={category.href}>{t(category.title)}</Tabs.Tab>
          </Link>
        ))}
        {isJa
          ? POLICY_CATEGORY_JA.map((category) => (
              <Link key={category.href} href={category.href}>
                <Tabs.Tab value={category.href}>{t(category.title)}</Tabs.Tab>
              </Link>
            ))
          : null}
      </Tabs.List>
    </Tabs>
  );
};
